import { updateInventorySupplier } from "../../api/inventoryService";

export const useUpdateInventorySupplier = (successCallback) => {
  const update = async (id, data) => {
    try {
        const updatedRecord = await updateInventorySupplier(id, data);
        if (successCallback) successCallback(updatedRecord);
        return updatedRecord;
    } catch (error) {
        console.error("Failed to update inventory supplier:", error);
        throw error;
    }
  };

  return { update };
};